import {
    Button,
    Checkbox,
    CircularProgress,
    IconButton,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import makeStyles from '@mui/styles/makeStyles';
import { API } from 'aws-amplify';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import ConfirmModal from '../../../common/ConfirmModal';
import EmailChips from '../../../common/EmailChips';
import TableDisplay from '../../../common/TableDisplay';
import { ACTIVITY_EMAIL_DIGEST, convertToTimeZone, TIMEZONES } from '../../../utils/utils';

const mapStateToProps = state => ({
    ...state
})
const useStyles = makeStyles(
    theme => ({
        searchAndNavigation: {
            '& button[aria-label="Clear Search"]': {
                color: 'var(--colorTitle)',
                '&.Mui-disabled': {
                    color: 'var(--colorSubtitle)',
                },
            },
            '& input::placeholder': {
                color: 'var(--colorSubtitle)',
                opacity: 1,
            },
            '& .MuiTablePagination-root .MuiIconButton-root': {
                color: 'var(--colorTitle)',
            },
            '& .MuiTablePagination-root .MuiSelect-icon': {
                color: 'var(--colorTitle)',
            }
        },
    })
);

function EmailDigest(props) {
    const classes = useStyles();
    const [digestsList, setDigestsList] = useState([]);
    const [deleting, setDeleting] = useState([]);
    const TIMEZONE = props?.user?.aboutMe?.currentTenant?.timezoneName;

    useEffect(() => {
        API.get('Core', `/api/v1/digest/settings?type=${props.type}`)
            .then(r => {
                setDigestsList(r);
            });
    }, []);

    let deleteDigest = (id) => {
        API.del('Core', `/api/v1/digest/settings/${id}`)
            .then(r => {
                var DIGEST_LIST = digestsList;
                DIGEST_LIST.splice(DIGEST_LIST.findIndex(dl => dl.id === id), 1);
                setDigestsList([...DIGEST_LIST]);
                toast('Digest deleted', { position: "top-center", type: "success" });
            })
            .catch(e => {
                console.error('Error digest delete ', e);
                toast(e.message, { position: "top-center", type: "error" })
            }).finally(() => {
                let _deleting = deleting
                _deleting = _deleting.splice(_deleting.findIndex(d => d.id === id), 1)
                setDeleting(_deleting)
            });
    }

    let goToCreateDigest = () => {
        props.history.push(`/settings/create-${props.type.toLowerCase() || 'cpss'}-digest-email`,);
    }

    let goToEditDigest = (id) => {
        props.history.push(`/settings/edit-digest-email/${id}`);
    }

    let toggleDigest = (id, index) => {
        const DIGEST = digestsList[index];
        DIGEST.active = !DIGEST.active;

        API.put('Core', `/api/v1/digest/settings/${id}`, { body: DIGEST })
            .then(r => {
                const SETTING = r;

                if (SETTING) {
                    digestsList[index] = SETTING;
                    setDigestsList([...digestsList]);
                    toast.success(`Digest Setting ${r.active ? 'enabled' : 'disabled'}!`, { position: "top-center" });
                }
            })
    }

    const COLUMNS = [
        { field: 'name', title: 'Name' },
        { field: 'frequency', title: 'Frequency' },
        {
            field: 'lastFireTime', title: 'Last Send', render: d => {
                return (<div>
                    {d.lastFireTime}
                </div>)
            }
        },
        {
            field: 'actions', title: 'Actions', render: (d) => {
                const index = digestsList.findIndex(item => item.id === d.id);
                return (<div style={{ display: 'flex', alignItems: "center" }}>
                    <IconButton color="primary" onClick={() => goToEditDigest(d.id)}>
                        <Edit />
                    </IconButton>
                    {!deleting.includes(d.id) ?
                        <ConfirmModal
                            title={"Delete Digest"}
                            text={(<span>Are you sure you want to delete this email digest?</span>)}
                            onConfirm={() => {
                                setDeleting([...deleting, ...[d.id]])
                                deleteDigest(d.id)
                            }}
                            confirmTitle={"Delete"}
                        >
                            <IconButton color="primary">
                                <Delete />
                            </IconButton>
                        </ConfirmModal>
                        :
                        <CircularProgress size={18} />
                    }
                    <ConfirmModal
                        title={"Toggle Digest"}
                        text={(<span>Are you sure you want to {d.active ? 'disable' : 'enable'} this email digest?</span>)}
                        onConfirm={() => { toggleDigest(d.id, index) }}
                        confirmTitle={"Toggle"}
                    >
                        <Checkbox value={d.active} checked={d.active} />
                    </ConfirmModal>

                </div>);
            }
        },
    ];

    return (
        <div>
            <div className='addDigestButton' onClick={goToCreateDigest}>
                <Add />
                Add digest
            </div>
            <div className={classes.searchAndNavigation}>
            <TableDisplay
                data={digestsList}
                title={props.title || 'Email digests'}
                columns={COLUMNS}
            />
            </div>
        </div>
    );
}

export default withRouter(connect(mapStateToProps)(EmailDigest));